module.exports = __webpack_public_path__ + "img/gha.caedb912.svg";